import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserPermissionsService } from '../admin/userPermissions/user-permissions.service';
import { SessionWrapperService } from '../session/session-wrapper.service';
import { IActualSystemMenuPermission, IActualSystemMenuPermissionList } from '../../models/base/base';

@Injectable({
  providedIn: 'root'
})
export class PermissionsListService {
  list: IActualSystemMenuPermissionList[] = [];
  allPermissions: IActualSystemMenuPermission[] = [];
  public listSubject = new BehaviorSubject<IActualSystemMenuPermissionList[]>([]);
  public allPermissionsSubject = new BehaviorSubject<IActualSystemMenuPermission[]>([]);
  userId: string;
  pagePermissions = new BehaviorSubject<IActualSystemMenuPermission>(null);
  constructor(
    private userPermission: UserPermissionsService,
    private sessionService: SessionWrapperService
  ) {}

  getPermissions(menuId: string) {
    this.userId = this.sessionService.getsessionData().userid;

    this.userPermission.getActualSystemMenuPermission(this.userId, menuId).subscribe({
      next: (res) => {
        // debugger
        const exist = this.list.find((el) => el.menuid === menuId);
        const existIndex = this.list.findIndex((el) => el.menuid === menuId);
        let list: IActualSystemMenuPermissionList = {
          menuid: menuId,
          list: res
        };
        if (exist) {
          this.list[existIndex] = list;
        } else {
          this.list.push(list);
        }
        this.pagePermissions.next(res[0]);
      }
    });
  }

  getPage(menuId: string) {
    this.userId = this.sessionService.getsessionData().userid;
    this.userPermission.getActualSystemMenuPermission(this.userId, menuId).subscribe({
      next: (res) => {
        this.pagePermissions.next(res[0]);
      }
    });
  }

  getAllPermissions() {
    this.userId = this.sessionService.getsessionData().userid;

    this.userPermission.getActualSystemMenuPermission(this.userId, null).subscribe({
      next: (res) => {
        this.allPermissions = res;
        this.allPermissionsSubject.next(this.allPermissions);
        // console.log('allPermissions', this.allPermissions);
      }
    });
  }

  getAllPermissionsList() {
    return this.allPermissionsSubject.asObservable();
  }

  getPagePermissions() {
    return this.pagePermissions.asObservable();
  }
}
